import {
  createRouteRef,
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:techdocs` with the repository docs reader. `noHeader`
 * suppresses the `PluginHeader` the blueprint would otherwise stack above the
 * page's own branded `Header`.
 */
export const docsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/docs',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'techdocs.root' }),
        loader: () =>
          import('./RepositoryDocsPage').then(m => (
            <PageErrorBoundary title="Docs">
              <m.RepositoryDocsPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
